<section class="container">
  <div class="header">
    <span class="header-title">{{"Recharge.title" | translate}}</span>
    <a *ngIf="!showAll && displayedRecords.length > 0" class="header-more" [routerLink]="['/invoices']">
      {{"Recharge.loadMore" | translate }} <app-chevron-right></app-chevron-right>
    </a>
  </div>
  <div class="redline"></div>
  <ng-container *ngIf="displayedRecords.length > 0; else noRecordsTemplate">
    <ul class="list">
      <app-record *ngFor="let record of displayedRecords" [image]="record.image" [name]="record.name"
        [price]="record.price" [timeProp]="record.time" [paid]="record.paid"></app-record>
    </ul>
  </ng-container>
  <ng-template #noRecordsTemplate>
    <div class="no-records" *ngIf="shouldShowNoRecords">
      {{"Recharge.noRecord" | translate }}
    </div>
  </ng-template>
</section>